export const VEC_ICON_NAME = {
    DASHBOARD_ICON: "DashboardIcon",
    TAX1099_LOGO: "Tax1099Logo",
    PRE_LOGIN_IMAGE: "PreLoginImage",
    USER_PROFILE: "UserProfile",
    EMAIL_ICON: "Email",
    PASSWORD_ICON: "Password",
    TOGGLE_PASSWORD_ICON: "TogglePassword",
    FORMS_ICON: "FormsIcon",
    NOTICES_ICON: "NoticesIcon",
    PAYER_ICON: "PayerIcon",
    RECIPIENT_ICON: "RecipientIcon",
    REPORTS_ICON: "ReportsIcon",
    HISTORY_ICON: "HistoryIcon",
    SUPPORT_ICON: "SupportIcon",
    USERS_ICON: "UsersIcon",
    CARET_DOWN: "CaretDown",
    CLOSE: "Close",
    FOOTER_IMAGE: "FooterImage",
    CIRCULAR_CHECKBOX: "CircularCheckBox",
    UPLOAD_FROM_COMPUTER: "UploadFromComputer",
    INFO_ICON: "InfoIcon",
    WALLET_ICON: "WalletIcon",
    PRE_LOGIN_FEATURE_ICON1: "PreLoginFeatureIcon1",
    PRE_LOGIN_FEATURE_ICON2: "PreLoginFeatureIcon2",
    PRE_LOGIN_FEATURE_ICON3: "PreLoginFeatureIcon3",
    GOOGLE_LOGIN_ICON: "GoogleLoginIcon",
    APPLE_LOGIN_ICON: "AppleLoginIcon",
    QUICK_BOOKS_LOGIN_ICON: "QuickBooksLoginIcon",
    QUICK_BOOKS_DESKTOP_LOGO: "QuickBooksDesktopLogo",
    QUICK_BOOKS_ONLINE_LOGO: "QuickBooksOnlineLogo",
    BILL_LOGO: "BillLogo",
    XERO_LOGO: "XeroLogo",
    ZOHO_BOOKS_LOGO: "ZohoBooksLogo",
    SAGE_LOGO: "SageLogo",
    ORACLE_NETSUITE_LOGO: "OracleNetsuiteLogo",
    ENTRATA_LOGO: "EntrataLogo",
    FRESH_BOOKS_LOGO: "FreshBooksLogo",
    ACCOUNTING_SUITE_LOGO: "AccountingSuiteLogo",
    TIPALTI_LOGO: "TipaltiLogo",
    W9PDF_IMPORT_LOGO: "W9PDFImportLogo",
    EXCEL_IMPORT_LOGO: "ExcelImportLogo",
    AZURE_LOGIN_ICON: "AzureLoginIcon",
    WELCOME_STEP_ICON: "WelcomeStepIcon",
    API_INTEGRATION_ICON: "ApiIntegrationIcon",
    ICON_DROPDOWN_CARET: "IconDropdownCaret",
    CHECKBOX_ICON: "CheckBoxIcon",
    SEARCH_ICON: "SearchIcon",
    LOGOUT: "Logout",
    PAYER_TYPE_INDIVIDUAL: "PayerTypeIndividual",
    PAYER_TYPE_BUSINESS: "PayerTypeBusiness",
    RADIO_BUTTON_ICON: "RadioButtonIcon",
    PAYER_ADDED_SUCCESS: "PayerAddedSuccess",
    CIRCULAR_PLUS_ICON: "CircularPlusIcon",
    CIRCULAR_LEFT_ARROW: "CircularLeftArrow",
    CIRCULAR_RIGHT_ARROW: "CircularRightArrow",
    GET_COMPANY_STEP_ICON: "GetCompanyStepIcon",
    DOWNLOAD_ICON: 'DownloadIcon',
    DRAG_AND_DROP_FILE_ICON: 'DragAndDropFileIcon',
    BULK_PAYER_ADDED_SUCCESS: "BulkPayerAddedSuccess",
    PAYER_TYPE_INDIVIDUAL_SMALL: "PayerTypeIndividualSmall",
    PAYER_TYPE_BUSINESS_SMALL: "PayerTypeBusinessSmall",
    DOWNLOAD_ICON_V2: "DownloadIconV2",
    WARNING_ICON: "WarningIcon",
    TRADE_ICON: "TradeIcon",
    SORT_ICON: "SortIcon",
    FILTER_ICON: "FilterIcon",
    USER_ICON: "UserIcon",
    PHONE_ICON: "PhoneIcon",
    BUISNESS_ICON: "BuisnessIcon",
    CLIENT_ICON: "ClientIcon",
    HOME_ICON: "HomeIcon",
    CIRCULAR_TICK_ICON: "CircularTickIcon",
    EMAIL_GREY_ICON: "EmailGreyIcon",
    ALERT_ICON: "AlertIcon",
    MULTIPLE_SELECT_ICON: "MultipleSelectIcon",
    ASSIGN_TO_USER_ICON: "AssignToUserIcon",
    REPORT_ICON: "ReportIcon",
    DEACTIVATE_ICON: "DeactivateIcon",
    DELETE_ICON: "DeleteIcon",
    CHECKBOX_DASH_ICON: "CheckboxDashIcon",
    BANK_LOGO_ICON: "BankLogoIcon",
    INVOICE_LOGO_ICON: "InvoiceLogoIcon",
    EXCEL_SHEET_LOGO: "ExcelSheetLogo",
    CSV_FILE_LOGO: "CsvFileLogo",
    XLSX_FILE_LOGO: "XlsxFileLogo",
    DOC_FILE_LOGO: "DocFileLogo",
    DEFAULT_FILE_LOGO: "DefaultFileLogo",
    CREATE_FORM_SUCCESS: "CreateFormSuccess",
    CREATE_FORM_SUCCESS_PAYER_ICON: "CreateFormSuccessPayerIcon",
    CREATE_FORM_SUCCESS_RECIPIENT_ICON: "CreateFormSuccessRecipientIcon",
    VISA: "VisaCardIcon",
    START_TICK_ICON: "StarTickIcon",
    CIRCULAR_EXCLAMATORY: "CircularExclamatory",
    COPY_ICON: "CopyIcon",
    EDIT_ICON: "EditIcon",
    PROGRESS_ICON: "ProgressIcon",
    PAYER_ICON_2: "PayerIcon2",
    RECIPIENT_ICON_2: "RecipientIcon2",
    READY_TO_SUBMIT: "ReadyToSubmit",
    ALERT_ICON_SM: "AlertIconSM",
    INDIVIDUAL_ROUND_ICON: "IndividualRoundIcon",
    INDIVIDUAL_FORM_ICON: "IndividualFormIcon",
    WALLET_ICON_WITH_BOX: "WalletIconWithBox",
    UPGRADE_PLAN_ICON: 'UpgradePlanIcon',
    LOGOUT_ICON: 'logoutIcon',
    HELP_SUPPORT_ICON: 'helpSupportIcon',
    CHANGE_PASSWORD_ICON: 'changePasswordIcon',
    ACTIVITY_LOG_ICON: 'activityLogIcon',
    TWO_FA_ICON: 'twoFAIcon',
    CHANGE_PASSWORD_PAGE_VECTOR: 'changePasswordPageVector',
    GREEN_CHECK_MARK: 'greenCheckMark',
    PROFILE_EDIT_ICON: 'profileEditIcon',
    GREEN_TICK_ICON: 'greenTickIcon',
    RED_CROSS_ICON: 'redCrossIcon',
    TWO_FA_VECTOR: 'twoFAVector',
    EFILE_PLUS_VECTOR: 'eFilePlusVector',
    ENTERPRISE_VECTOR: 'enterpriseVector',
    ESSENTIAL_VECTOR: 'essentialVector',
    PAYMENT_SUCCESS_DRAWER_ICON: "PaymentSuccessDrawerIcon",
    STAR_ICON: "StarIcon",
    API_ICON: 'ApiIcon',
    POINTER_ICON: 'PointerIcon',
    NEED_HELP_ICON: 'NeedHelpIcon',
    CREATE_FORM_VECTOR: 'CreateFormVector',
    CREATE_FORM_VECTOR_MINI: 'CreateFormVectorMini',
    CREATE_FORM_ICON: 'CreateFormIcon',
    ADD_PAYER_VECTOR: 'AddPayerVector',
    ADD_PAYER_VECTOR_MINI: 'AddPayerVectorMini',
    ADD_PAYER_ICON: 'AddPayerIcon',
    ADD_RECIPIENT_VECTOR: 'AddRecipientVector',
    ADD_RECIPIENT_VECTOR_MINI: 'AddRecipientVectorMini',
    EXPLORE_PLAN_VECTOR: 'ExplorePlanVector',
    GENERAL_ICON: 'GeneralIcon',
    RIGHT_ARROW_OUTLINE: 'RightArrowOutline',
    SHORTCUT_ICON: 'ShortcutIcon',
    NEW_TAB_ICON: 'NewTabIcon',
    PDF_ICON: 'PDFIcon',
    HORIZONTAL_ELLIPSIS: 'HorizontalEllipsis',
    VIEW_ICON: 'ViewIcon',
    SHARE_ICON: 'ShareIcon',
    REVOKE_ICON: 'RevokeIcon',
    ERROR_ICON: 'ErrorIcon',
    IMPORT_ICON: 'ImportIcon',
    FORM_RECOMMEND_ICON: "formRecommendIcon",
    EFILE_PLUS_RIBBON: "eFilePlusRibbon",
    ENTERPRISE_RIBBON: "enterpriseRibbon",
    ESSENTIAL_RIBBON: "essentialribbon",
    BULK_IMPORT_ICON: 'bulkImportIcon',
    THREE_DOT_MENU_ICON: "threeDotMenuIcon",
    CHAT_ICON :"chatIcon",
    DRAG_ICON: "DragIcon",
    EXPORT_ICON: 'ExportIcon',
    RECIPIENT_DETAILS_ICON: 'RecipeintDetailsIcon',
    SUBMIT_FORM_ICON: 'SubmitFormIcon',
    BILL_DUE_ICON: 'BillDueIcon',
    TIN_VERIFICATION_VECTOR_MINI: 'TinVerificationVectorMini',
    FORMS_MINI_VECTOR: 'FormsMiniVector',
    MANAGE_CARDS_VECTOR: "ManageCardsVector",
    HELP_INFO_ICON: "HelpInfoIcon",
    BOI_REPORTING_ICON: "BoiReportingIcon",
    FINCEN_BOI_SIDEBAR_ICON: "FincenBOISidebarIcon",
    ALL_MENU_ICON: "AllMenuIcon",
    FBAR_ONLINE_ICON: "FBAROnlineIcon",
    EZ_EXTENSION_ICON: "EZExtensionIcon",
    EZ_2290_ICON: "EZ2290Icon",
    PAPER_SCROLL_ICON: "PaperScrollIcon",
    BOI_BOY_W_QUESTION_ICON: "BoiBoyWQuestionIcon",
    BOI_GIRL_ICON: "BoiGirlIcon",
    BOI_QUIZ_COMPLETION_ICON: "BoiQuizCompletionIcon",
    SUBMIT_PAYMENT_ICON: "SubmitPaymentIcon",
}